import { useLayoutEffect, useRef } from "react";

export const useFixedElementSpacer = <T extends HTMLElement>(
  enabled: boolean,
) => {
  const contentRef = useRef<T>(null);
  const spacerRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (!enabled) return;

    const content = contentRef.current;
    const spacer = spacerRef.current;
    if (!content || !spacer) return;

    const updateSpacerHeight = () => {
      spacer.style.height = `${content.getBoundingClientRect().height}px`;
    };
    updateSpacerHeight();

    const resizeObserver = new ResizeObserver(updateSpacerHeight);
    resizeObserver.observe(content);
    return () => resizeObserver.disconnect();
  }, [enabled]);

  return { contentRef, spacerRef };
};
